import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const INVALID = "This link is not valid. Reply to our email with 'unsubscribe' and we will remove you.";
const GENERIC = "We could not process your request. Please try again shortly.";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const e = params.get("e") || "";
  const s = params.get("s") || "";
  const [state, setState] = useState(e && s ? "ready" : "invalid");
  const [message, setMessage] = useState(e && s ? "" : INVALID);

  async function onSubmit(ev) {
    ev.preventDefault();
    setState("busy");
    try {
      const r = await fetch("/api/unsubscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ e, s }),
      });
      const data = await r.json().catch(() => ({}));
      if (r.ok && data.ok) setState("done");
      else if (r.status === 400) { setState("invalid"); setMessage(INVALID); }
      else { setState("ready"); setMessage(GENERIC); }
    } catch {
      setState("ready");
      setMessage(GENERIC);
    }
  }

  return (
    <section>
      <div className="wrap">
        <div className="gate">
          <div className="eyebrow">Email preferences</div>
          {state === "done" ? (
            <div role="status" aria-live="polite">
              <h1>Done.</h1>
              <p className="sub center">You will not receive further emails from Daksfirst.</p>
            </div>
          ) : state === "invalid" ? (
            <>
              <h1>Stop emails from Daksfirst.</h1>
              <p className="sub center" role="alert">{message}</p>
            </>
          ) : (
            <form onSubmit={onSubmit}>
              <h1>Stop emails from Daksfirst.</h1>
              <p className="sub center">
                Unsubscribe <strong style={{ color: "var(--white)" }}>{e}</strong> from the
                Daksfirst Market Brief and other Daksfirst emails.
              </p>
              {message && <p className="field-error" role="alert" style={{ marginBottom: 16 }}>{message}</p>}
              <button className="btn btn-primary" type="submit" disabled={state === "busy"}>
                {state === "busy" ? "Working…" : "Unsubscribe"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
